import {
  CODES_INVENTORY,
  CountryInfo,
} from '@marketmuse/config/types/countries';
import config from '@marketmuse/config/configs/countries';

export const getCountriesForInventory = (): CountryInfo[] => {
  return Object.values(CODES_INVENTORY).map(code => config[code]);
};
